import { useCreate } from '@inmagik/react-crud'
import { API_URL } from '../constants'
import { Proposta_FormCliente, Proposta_FormCliente_Compilato } from '../types'
import { useAction, useData } from './useData'

export function useFormProposta(id: string | number, token?: string) {
  return useData<Proposta_FormCliente>(
    `${API_URL}/bilance/form/proposta/${id}`,
    {
      headers: { 'X-Token-Cliente': token || '' },
    }
  )
}

export function useSaveFormProposta(id: string | number, token?: string) {
  return useAction<unknown, Proposta_FormCliente_Compilato>(
    `${API_URL}/bilance/form/proposta/${id}`,
    {
      method: 'POST',
      headers: { 'X-Token-Cliente': token || '' },
      responseType: 'raw',
    }
  )
}
